import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import { Helmet } from 'react-helmet';
import metaImage from '../images/balthazaurus.jpg';

export default function SEO({ children, location, description, title, image }) {
  const {
    site: { siteMetadata },
  } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          description
          siteUrl
        }
      }
    }
  `);
  return (
    <Helmet titleTemplate={`%s – ${siteMetadata.title}`}>
      <html lang="en" />
      <title>{title}</title>
      {/* Favicons */}
      <link
        rel="icon"
        type="image/svg+xml"
        href={`${siteMetadata.siteUrl}/favicon.ico`}
      />
      {/* Meta tags */}
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, shrink-to-fit=no"
      />
      <meta charSet="utf-8" />
      <meta
        name="description"
        content={description || siteMetadata.description}
      />
      {/* Open Graph */}
      {location && <meta property="og:url" content={location.href} />}
      <meta
        property="og:image"
        content={image || `${siteMetadata.siteUrl}${metaImage}`}
      />
      <meta
        property="og:title"
        content={`${title} – ${siteMetadata.title}` || siteMetadata.title}
        key="ogtitle"
      />
      <meta
        property="og:site_name"
        content={siteMetadata.title}
        key="ogsitename"
      />
      <meta
        property="og:description"
        content={description || siteMetadata.description}
        key="ogdesc"
      />
      {/* Google analytics && Hotjar included through Gatsby plugins – see gatsby-config.js */}
      {/* Allow additional tags to be inject on a per-page basis */}
      {children}
    </Helmet>
  );
}
